export const points={
    1200: {
        slidesPerView: 10.5, // Desktop: 8 slides per row
    },
    992: {
        slidesPerView: 8.5, // Tablet: 6 slides per row
    },
    768: {
        slidesPerView: 5.5, // Smaller tablets: 4 slides per row
    },
    576: {
        slidesPerView: 3.5, // Mobile: 2 slides per row
    },
}


export const bigWinPoints = {
    1200: {
        slidesPerView: 10,
    },
    992: {
        slidesPerView: 8,
    },
    768: {
        slidesPerView: 4,
    },
    576: {
        slidesPerView: 3, // Correct this if it's meant for small screens
    },
};


export const providerPoints={
    1200: {
        slidesPerView: 12, // Desktop: 8 slides per row
    },
    992: {
        slidesPerView: 8, // Tablet: 6 slides per row
    },
    768: {
        slidesPerView: 6, // Smaller tablets: 4 slides per row
    },
    576: {
        slidesPerView: 6, // Mobile: 2 slides per row
    },
}
export const miniGamePoints={
    1200: {
        slidesPerView: 4, // Desktop: 8 slides per row
    },
    992: {
        slidesPerView: 3, // Tablet: 6 slides per row
    },
    768: {
        slidesPerView: 2, // Smaller tablets: 4 slides per row
    },
    576: {
        slidesPerView: 2, // Mobile: 2 slides per row
    },
}


export const providersPoints={
    1200: {
        slidesPerView: 8, // Desktop: 8 slides per row
    },
    992: {
        slidesPerView: 6, // Tablet: 6 slides per row
    },
    768: {
        slidesPerView: 4, // Smaller tablets: 4 slides per row
    },
    576: {
        slidesPerView: 2, // Mobile: 2 slides per row
    },
}
